<template>
  <div
    class="w-full h-screen flex flex-col items-center justify-center gap-4 animate-fade-in"
    :class="isDark ? 'bg-[#1a1c20] text-white' : 'bg-gray-50 text-black'"
  >
    <icon-base name="Refresh" class="w-8 h-8 animate-spin text-amber-500" />
    <div class="text-sm font-bold opacity-60">正在查询支付结果...</div>
  </div>
</template>

<script>
import { orderState } from "@/api/index";

export default {
  name: "PayNotify",
  data() {
    return {
      isDark:
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches,
    };
  },
  created() {
    this.checkPayStatus();
  },
  methods: {
    async checkPayStatus() {
      const { out_trade_no } = this.$route.query;
      if (!out_trade_no) {
        this.$router.replace({ path: "/app", query: { payStatus: "failed" } });
        return;
      }

      try {
        const res = await orderState(out_trade_no);
        if (res.trade_state === "SUCCESS") {
          // 支付成功，回计时器主页并带上成功参数
          this.$router.replace({
            path: "/app",
            query: { payStatus: "success" },
          });
        } else {
          // 支付未完成，回计时器主页并带上失败参数
          this.$router.replace({
            path: "/app",
            query: { payStatus: "failed" },
          });
        }
      } catch (error) {
        console.error("Check pay status error:", error);
        // this.$router.replace({ path: "/", query: { payStatus: "failed" } });
      }
    },
  },
};
</script>
